
<v-main class="background">
	<router-view></router-view>
</v-main>
